// extracted by mini-css-extract-plugin
module.exports = {"melodyRule":"_e-z"};